import { render, staticRenderFns } from "./VirtualSeviceToDestinationRule.vue?vue&type=template&id=39f3ec1d&"
import script from "./VirtualSeviceToDestinationRule.vue?vue&type=script&lang=js&"
export * from "./VirtualSeviceToDestinationRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports